import mock from '../mock';
import { providerData } from '@providers';

const providersDB = {
	providers: [
		// IBM Cloud
		{
			id: 'ibm',
			name: 'IBM Cloud',
			authentications: [
				{ id: 'apiKey', label: 'API Key', type: 'password', icon: 'vpn_key', required: true },
				{ id: 'accountId', label: 'Account ID', type: 'text', icon: 'account_circle', required: false },
				{ id: 'resourceGroupId', label: 'Resource Group ID', type: 'text', icon: 'layers', required: false },
				{ id: 'region', label: 'Region', type: 'text', icon: 'location_on', required: false }
			],
			regions: [],
			instanceSizes: []
		},
		// ORACLE CLOUD
		{
			id: 'oracle',
			name: 'Oracle Cloud',
			authentications: [
				{
					id: 'user_ocid',
					label: 'User OCID',
					type: 'text',
					icon: 'account_circle',
					required: true
				},
				{
					id: 'tenancy_ocid',
					label: 'Tenancy OCID',
					type: 'text',
					icon: 'account_circle',
					required: true
				},
				{
					id: 'compartment_ocid',
					label: 'Compartment OCID',
					type: 'text',
					icon: 'account_circle',
					required: true
				},
				{
					id: 'key_file',
					label: 'Key File',
					type: 'password',
					icon: 'vpn_key',
					required: true
				},
				{
					id: 'fingerprint',
					label: 'Fingerprint ',
					type: 'text',
					icon: 'public',
					required: true
				}
			],
			regions: [
				{ name: 'US Ashburn 1', region_id: 'us-ashburn-1' },
				{ name: 'US Phoenix 1', region_id: 'us-phoenix-1' },
				{ name: 'CA Toronto 1', region_id: 'ca-toronto-1' },
				{ name: 'UK London 1', region_id: 'uk-london-1' },
				{ name: 'EU Frankfurt 1', region_id: 'eu-frankfurt-1' },
				{ name: 'EU Zurich 1', region_id: 'eu-zurich-1' }
			],
			instanceSizes: [
				{
					name: 'VM.Standard2.1 - vCPU: 1, Mem (GB): 15',
					instance_id: 'VM.Standard2.1',
					cores: '1'
				},
				{
					name: 'VM.Standard2.2 - vCPU: 2, Mem (GB): 30',
					instance_id: 'VM.Standard2.2',
					cores: '2'
				},
				{
					name: 'VM.Standard2.4 - vCPU: 4, Mem (GB): 60',
					instance_id: 'VM.Standard2.4',
					cores: '4'
				},
				{
					name: 'VM.Standard2.8 - vCPU: 8, Mem (GB): 120',
					instance_id: 'VM.Standard2.8',
					cores: '8'
				},
				{
					name: 'VM.Standard2.16 - vCPU: 16, Mem (GB): 240',
					instance_id: 'VM.Standard2.16',
					cores: '16'
				},
				{
					name: 'VM.Standard2.24 - vCPU: 24, Mem (GB): 320',
					instance_id: 'VM.Standard2.24',
					cores: '24'
				},
				{
					name: 'VM.Standard3.Flex - Max OCPUs: 32, Max Mem (GB): 512',
					instance_id: 'VM.Standard3.Flex',
					cores: '32'
				},
				{
					name: 'VM.Standard.E3.Flex - Max OCPUs: 64, Max Mem (GB): 1024',
					instance_id: 'VM.Standard.E3.Flex',
					cores: '64'
				},
				{
					name: 'VM.Standard.E4.Flex - Max OCPUs: 64, Max Mem (GB): 1024',
					instance_id: 'VM.Standard.E4.Flex',
					cores: '64'
				},
				{
					name: 'VM.Optimized3.Flex - Max OCPUs: 18, Max Mem (GB): 256',
					instance_id: 'VM.Optimized3.Flex',
					cores: '18'
				},
				{
					name: 'BM.Optimized3.36 - oCPU: 36, Mem (GB): 512',
					instance_id: 'BM.Optimized3.36',
					cores: '52'
				},
				{
					name: 'BM.GPU4.8 - oCPU: 32, Mem (GB): 2048',
					instance_id: 'BM.GPU4.8',
					cores: '32'
				}
			]
		},
		// AWS
		{
			id: 'aws',
			name: 'Amazon Web Services',
			authentications: [
				{
					id: 'access_key',
					label: 'Access Key',
					type: 'password',
					icon: 'vpn_key',
					required: true
				},
				{
					id: 'secret_key',
					label: 'Secret Key',
					type: 'password',
					icon: 'vpn_key',
					required: true
				},
				{
					id: 'session_token',
					label: 'Session Token',
					type: 'password',
					icon: 'vpn_key',
					required: false
				}
			],
			regions: [
				{
					name: 'US East 1',
					region_id: 'us-east-1',
					zones: [
						{
							name: 'US East 1a',
							zone_id: 'use1-az1'
						},
						{
							name: 'US East 1b',
							zone_id: 'use1-az2'
						},
						{
							name: 'US East 1c',
							zone_id: 'use1-az4'
						},
						{
							name: 'US East 1d',
							zone_id: 'use1-az6'
						},
						{
							name: 'US East 1e',
							zone_id: 'use1-az3'
						},
						{
							name: 'US East 1f',
							zone_id: 'use1-az5'
						}
					]
				},
				{
					name: 'US West 1',
					region_id: 'us-west-1',
					zones: [
						{
							name: 'US West 1a',
							zone_id: 'usw1-az3'
						},
						{
							name: 'US West 1b',
							zone_id: 'usw1-az1'
						}
					]
				},
				{
					name: 'US Gov East 1',
					region_id: 'us-gov-east-1',
					zones: [
						{
							name: 'US Gov East 1a',
							zone_id: 'usge1-az1'
						},
						{
							name: 'US Gov East 1b',
							zone_id: 'usge1-az2'
						},
						{
							name: 'US Gov East 1c',
							zone_id: 'usge1-az3'
						}
					]
				},
				{
					name: 'US Gov West 1',
					region_id: 'us-gov-west-1',
					zones: [
						{
							name: 'US Gov West 1a',
							zone_id: 'usgw1-az1'
						},
						{
							name: 'US Gov West 1b',
							zone_id: 'usgw1-az2'
						},
						{
							name: 'US Gov West 1c',
							zone_id: 'usgw1-az3'
						}
					]
				},
				{
					name: 'US West 2 Ohio',
					region_id: 'us-west-2',
					zones: [
						{
							name: 'US East 2a',
							zone_id: 'us-east-2a'
						},
						{
							name: 'US East 2b',
							zone_id: 'us-east-2b'
						},
						{
							name: 'US East 2c',
							zone_id: 'us-east-2c'
						}
					]
				},
				{
					name: 'CA Central 1',
					region_id: 'ca-central-1',
					zones: [
						{
							name: 'CA Central 1a',
							zone_id: 'cac1-az1'
						},
						{
							name: 'CA Central 1b',
							zone_id: 'cac1-az2'
						},
						{
							name: 'CA Central 1d',
							zone_id: 'cac1-az4'
						}
					]
				},
				{
					name: 'EU Central 1',
					region_id: 'eu-central-1',
					zones: [
						{
							name: 'EU Central 1a',
							zone_id: 'euc1-az2'
						},
						{
							name: 'EU Central 1b',
							zone_id: 'euc1-az3'
						},
						{
							name: 'EU Central 1c',
							zone_id: 'euc1-az1'
						}
					]
				},
				{
					name: 'EU West 1',
					region_id: 'eu-west-1',
					zones: [
						{
							name: 'EU West 1a',
							zone_id: 'euw1-az3'
						},
						{
							name: 'EU West 1b',
							zone_id: 'euw1-az1'
						},
						{
							name: 'EU West 1c',
							zone_id: 'euw1-az2'
						}
					]
				}
			],
			instanceSizes: [
				{
					name: 't2.nano - vCPU: 1, Mem (GB): 0.50',
					instance_id: 't2.nano',
					cores: '1'
				},
				{
					name: 't2.micro - vCPU: 1, Mem (GB): 1',
					instance_id: 't2.micro',
					cores: '1'
				},
				{
					name: 't2.small - vCPU: 1, Mem (GB): 2',
					instance_id: 't2.small',
					cores: '1'
				},
				{
					name: 't2.medium - vCPU: 2, Mem (GB): 4',
					instance_id: 't2.medium',
					cores: '2'
				},
				{
					name: 't2.large - vCPU: 2, Mem (GB): 8',
					instance_id: 't2.large',
					cores: '2'
				},
				{
					name: 't2.xlarge - vCPU: 4, Mem (GB): 16',
					instance_id: 't2.xlarge',
					cores: '4'
				},
				{
					name: 't2.2xlarge - vCPU: 8, Mem (GB): 32',
					instance_id: 't2.2xlarge',
					cores: '8'
				},

				{
					name: 't3.nano - vCPU: 2, Mem (GB): 0.50',
					instance_id: 't3.nano',
					cores: '2'
				},
				{
					name: 't3.micro - vCPU: 2, Mem (GB): 1',
					instance_id: 't3.micro',
					cores: '2'
				},
				{
					name: 't3.small - vCPU: 2, Mem (GB): 2',
					instance_id: 't3.small',
					cores: '2'
				},
				{
					name: 't3.medium - vCPU: 2, Mem (GB): 4',
					instance_id: 't3.medium',
					cores: '2'
				},
				{
					name: 't3.large - vCPU: 2, Mem (GB): 8',
					instance_id: 't3.large',
					cores: '2'
				},
				{
					name: 't3.xlarge - vCPU: 4, Mem (GB): 16',
					instance_id: 't3.xlarge',
					cores: '4'
				},
				{
					name: 't3.2xlarge - vCPU: 8, Mem (GB): 322',
					instance_id: 't3.2xlarge',
					cores: '8'
				}
			]
		},
		// GOOGLE
		{
			id: 'gcp',
			name: 'Google Cloud',
			authentications: [
				{
					id: 'type',
					type: 'text',
					label: 'Type',
					icon: 'account_circle',
					required: true
				},
				{
					id: 'project_id',
					type: 'text',
					label: 'Project Id',
					icon: 'assignment',
					required: true
				},
				{
					id: 'private_key_id',
					type: 'password',
					label: 'Private Key Id',
					icon: 'vpn_key',
					required: true
				},
				{
					id: 'private_key',
					type: 'password',
					label: 'Private Key',
					icon: 'vpn_key',
					required: true
				},
				{
					id: 'client_email',
					type: 'text',
					label: 'Client Email',
					icon: 'email',
					required: true
				},
				{
					id: 'client_id',
					type: 'password',
					label: 'Client Id',
					icon: 'account_circle',
					required: true
				},
				{
					id: 'auth_uri',
					type: 'text',
					label: 'Auth URI',
					icon: 'public',
					required: true
				},
				{
					id: 'token_uri',
					type: 'text',
					label: 'Token URI',
					icon: 'public',
					required: true
				},
				{
					id: 'auth_provider_x509_cert_url',
					type: 'text',
					label: 'Auth Provider x509 Cert URL',
					icon: 'public',
					required: true
				},
				{
					id: 'client_x509_cert_url',
					type: 'text',
					label: 'Client x509 Cert URL',
					icon: 'public',
					required: true
				}
			],
			regions: [
				{
					name: 'US East 1',
					region_id: 'us-east1',
					zones: [
						{
							name: 'US East 1b',
							zone_id: 'us-east1-b'
						},
						{
							name: 'US East 1c',
							zone_id: 'us-east1-c'
						},
						{
							name: 'US East 1d',
							zone_id: 'us-east1-d'
						}
					]
				},
				{
					name: 'US Central 1',
					region_id: 'us-central1',
					zones: [
						{
							name: 'US Central 1a',
							zone_id: 'us-central1-a'
						},
						{
							name: 'US Central 1b',
							zone_id: 'us-central1-b'
						},
						{
							name: 'US Central 1c',
							zone_id: 'us-central1-c'
						},
						{
							name: 'US Central 1f',
							zone_id: 'us-central1-f'
						}
					]
				},
				{
					name: 'US West 1',
					region_id: 'us-west1',
					zones: [
						{
							name: 'US West 1a',
							zone_id: 'us-west1-a'
						},
						{
							name: 'US West 1b',
							zone_id: 'us-west1-b'
						},
						{
							name: 'US West 1c',
							zone_id: 'us-west1-c'
						}
					]
				},
				{
					name: 'North America Northeast 1',
					region_id: 'northamerica-northeast1',
					zones: [
						{
							name: 'North America Northeast 1a',
							zone_id: 'northamerica-northeast1-a'
						},
						{
							name: 'North America Northeast 1b',
							zone_id: 'northamerica-northeast1-b'
						},
						{
							name: 'North America Northeast 1c',
							zone_id: 'northamerica-northeast1-c'
						}
					]
				},
				{
					name: 'Europe North 1',
					region_id: 'europe-north1',
					zones: [
						{
							name: 'Europe North 1b',
							zone_id: 'europe-north1-b'
						},
						{
							name: 'Europe North 1c',
							zone_id: 'europe-north1-c'
						},
						{
							name: 'Europe North 1a',
							zone_id: 'europe-north1-a'
						}
					]
				},
				{
					name: 'Europe West 1',
					region_id: 'europe-west1',
					zones: [
						{
							name: 'Europe West 1b',
							zone_id: 'europe-west1-b'
						},
						{
							name: 'Europe West 1c',
							zone_id: 'europe-west1-c'
						},
						{
							name: 'Europe West 1d',
							zone_id: 'europe-west1-d'
						}
					]
				},
				{
					name: 'South America East 1',
					region_id: 'southamerica-east1',
					zones: [
						{
							name: 'South America East 1a',
							zone_id: 'southamerica-east1-a'
						},
						{
							name: 'South America East 1b',
							zone_id: 'southamerica-east1-b'
						},
						{
							name: 'South America East 1c',
							zone_id: 'southamerica-east1-c'
						}
					]
				}
			],
			instanceSizes: [
				{
					name: 'n1-standard-1 - vCPU: 1, Mem (GB): 3.75',
					instance_id: 'n1-standard-1',
					cores: '1'
				},
				{
					name: 'n1-standard-2 - vCPU: 2, Mem (GB): 7.50',
					instance_id: 'n1-standard-2',
					cores: '2'
				},
				{
					name: 'n1-standard-4 - vCPU: 4, Mem (GB): 15',
					instance_id: 'n1-standard-4',
					cores: '4'
				},
				{
					name: 'n1-standard-8 - vCPU: 8, Mem (GB): 30',
					instance_id: 'n1-standard-8',
					cores: '8'
				},
				{
					name: 'n1-standard-16 - vCPU: 16, Mem (GB): 60',
					instance_id: 'n1-standard-16',
					cores: '16'
				},
				{
					name: 'n1-standard-32 - vCPU: 32, Mem (GB): 120',
					instance_id: 'n1-standard-32',
					cores: '32'
				},
				{
					name: 'n1-standard-64 - vCPU: 64, Mem (GB): 240',
					instance_id: 'n1-standard-64',
					cores: '64'
				},
				{
					name: 'n1-standard-96 - vCPU: 96, Mem (GB): 360',
					instance_id: 'n1-standard-96',
					cores: '96'
				}
			]
		},
		// MAAS
		{
			id: 'maas',
			name: 'ACM',
			authentications: [
				{
					id: 'api_url',
					label: 'API URL',
					type: 'text',
					icon: 'link',
					required: true
				},
				{
					id: 'api_key',
					label: 'API Key',
					type: 'text',
					icon: 'vpn_key',
					required: true
				},
			],
			regions: [
			],
			instanceSizes: [
			]
		},
		// MICROSOFT AZURE
		{
			id: 'azure',
			name: 'Microsoft Azure',
			authentications: [
				{
					id: 'client_id',
					label: 'Client Id',
					type: 'text',
					icon: 'account_circle',
					required: true
				},
				{
					id: 'client_secret',
					label: 'Client Secret',
					type: 'password',
					icon: 'vpn_key',
					required: true
				},
				{
					id: 'subscription_id',
					label: 'Subscription Id',
					type: 'text',
					icon: 'account_circle',
					required: true
				},
				{
					id: 'tenant_id',
					label: 'Tenant Id',
					type: 'text',
					icon: 'account_circle',
					required: true
				}
			],
			regions: [
				{ name: 'East US', region_id: 'eastus' },
				{ name: 'Central US', region_id: 'centralus' },
				{ name: 'West US', region_id: 'westus' },
				{ name: 'Canada East', region_id: 'canadaeast' },
				{ name: 'France Central', region_id: 'francecentral' },
				{ name: 'Germany North', region_id: 'germanynorth' },
				{ name: 'North Europe', region_id: 'northeurope' },
				{ name: 'West Europe', region_id: 'westeurope' }
			],
			instanceSizes: [
				{
					name: 'Standard_DS1_v2 - vCPU: 1, Mem (GB): 3.50',
					instance_id: 'Standard_DS1_v2',
					cores: '1'
				},
				{
					name: 'Standard_DS2_v2 - vCPU: 2, Mem (GB): 7',
					instance_id: 'Standard_DS2_v2',
					cores: '2'
				},
				{
					name: 'Standard_DS3_v2 - vCPU: 4, Mem (GB): 14',
					instance_id: 'Standard_DS3_v2',
					cores: '4'
				},
				{
					name: 'Standard_DS4_v2 - vCPU: 8, Mem (GB): 28',
					instance_id: 'Standard_DS4_v2',
					cores: '8'
				},
				{
					name: 'Standard_DS5_v2 - vCPU: 16, Mem (GB): 56',
					instance_id: 'Standard_DS5_v2',
					cores: '16'
				}
			]
		},
	]
	// hash: {
	// 	't2.nano': '1',
	// 	't2.micro': '1',
	// 	't2.small': '1',
	// 	't2.medium': '2',
	// 	't2.large': '2',
	// 	't2.xlarge': '4',
	// 	't2.2xlarge': '8',
	// 	't3.nano': '2',
	// 	't3.micro': '2',
	// 	't3.small': '2',
	// 	't3.medium': '2',
	// 	't3.large': '2',
	// 	't3.xlarge': '4',
	// 	't3.2xlarge': '8',
	// 	'm5.large': '2',
	// 	'm5.xlarge': '4',
	// 	'm5.2xlarge': '8',
	// 	'm5.4xlarge': '16',
	// 	'm5.12xlarge': '48',
	// 	'm5.24xlarge': '96',
	// 	'm5d.large': '2',
	// 	'm5d.xlarge': '4',
	// 	'm5d.2xlarge': '8',
	// 	'm5d.4xlarge': '16',
	// 	'm5d.12xlarge': '48',
	// 	'm5d.24xlarge': '96',
	// 	'm4.large': '2',
	// 	'm4.xlarge': '4',
	// 	'm4.2xlarge': '8',
	// 	'm4.4xlarge': '16',
	// 	'm4.10xlarge': '40',
	// 	'm4.16xlarge': '64',
	// 	'n1-standard-1': '1',
	// 	'n1-standard-2': '2',
	// 	'n1-standard-4': '4',
	// 	'n1-standard-8': '8',
	// 	'n1-standard-16': '16',
	// 	'n1-standard-32': '32',
	// 	'n1-standard-64': '64',
	// 	'n1-standard-96': '96',
	// 	'n1-highmem-2': '2',
	// 	'n1-highmem-4': '4',
	// 	'n1-highmem-8': '8',
	// 	'n1-highmem-16': '16',
	// 	'n1-highmem-32': '32',
	// 	'n1-highmem-64': '64',
	// 	'n1-highmem-96': '96',
	// 	'n1-highcpu-2': '2',
	// 	'n1-highcpu-4': '4',
	// 	'n1-highcpu-8': '8',
	// 	'n1-highcpu-16': '16',
	// 	'n1-highcpu-32': '32',
	// 	'n1-highcpu-64': '64',
	// 	'n1-highcpu-96': '96',
	// 	Standard_DS1_v2: '1',
	// 	Standard_DS2_v2: '2',
	// 	Standard_DS3_v2: '4',
	// 	Standard_DS4_v2: '8',
	// 	Standard_DS5_v2: '16',
	// 	'VM.Standard2.1': '1',
	// 	'VM.Standard2.2': '2',
	// 	'VM.Standard2.4': '4',
	// 	'VM.Standard2.8': '8',
	// 	'VM.Standard2.16': '16',
	// 	'VM.Standard2.24': '24',
	// 	's2.small.1': '1',
	// 	's2.medium.2': 1,
	// 	's2.medium.4': 1,
	// 	's2.large.2': 2,
	// 	's2.large.4': 2,
	// 	's2.xlarge.2': 4,
	// 	's2.xlarge.4': 4,
	// 	's2.2xlarge.2': 8,
	// 	's2.2xlarge.4': 8,
	// 	's2.4xlarge.2': 16,
	// 	's2.4xlarge.4': 16,
	// 	'c3.15xlarge.2': 60,
	// 	'c3.15xlarge.4': 60,
	// 	'c3.2xlarge.2': 8,
	// 	'c3.2xlarge.4': 8,
	// 	'c3.4xlarge.2': 16,
	// 	'c3.4xlarge.4': 16,
	// 	'c3.8xlarge.2': 32,
	// 	'c3.8xlarge.4': 32,
	// 	'c3.large.2': 2,
	// 	'c3.large.4': 2,
	// 	'c3.xlarge.2': 4,
	// 	'c3.xlarge.4': 4,
	// 	'c4.16xlarge.2': 64,
	// 	'c4.16xlarge.4': 64,
	// 	'c4.2xlarge.2': 8,
	// 	'c4.2xlarge.4': 8,
	// 	'c4.3xlarge.2': 12,
	// 	'c4.3xlarge.4': 12,
	// 	'c4.4xlarge.2': 16,
	// 	'c4.4xlarge.4': 16,
	// 	'c4.6xlarge.2': 24,
	// 	'c4.6xlarge.4': 24,
	// 	'c4.8xlarge.2': 32,
	// 	'c4.8xlarge.4': 32,
	// 	'c4.large.2': 2,
	// 	'c4.large.4': 2,
	// 	'c4.xlarge.2': 4,
	// 	'c4.xlarge.4': 4,
	// 	'computev1-1': 1,
	// 	'computev1-2': 2,
	// 	'computev1-3': 4,
	// 	'computev1-4': 8,
	// 	'computev1-5': 16,
	// 	'computev1-6': 32,
	// 	'computev2-1': 1,
	// 	'computev2-2': 2,
	// 	'computev2-3': 4,
	// 	'computev2-4': 8,
	// 	'computev2-5': 16,
	// 	'computev2-6': 32,
	// 	'd1.2xlarge': 8,
	// 	'd1.4xlarge': 16,
	// 	'd1.8xlarge': 36,
	// 	'd1.xlarge': 4,
	// 	'd2.15xlarge.9': 60,
	// 	'd2.2xlarge.8': 8,
	// 	'd2.4xlarge.8': 16,
	// 	'd2.6xlarge.8': 24,
	// 	'd2.8xlarge.8': 32,
	// 	'd2.xlarge.8': 4,
	// 	'e1.2xlarge': 8,
	// 	'e1.4xlarge': 16,
	// 	'e1.8xlarge': 32,
	// 	'e1.xlarge': 4,
	// 	'e2.2xlarge': 8,
	// 	'e2.3xlarge': 12,
	// 	'e2.4xlarge': 18,
	// 	'e2.9xlarge': 36,
	// 	'e3.14xlarge.12': 56,
	// 	'e3.7xlarge.12': 28,
	// 	'g1.2xlarge': 8,
	// 	'g1.xlarge': 4,
	// 	'g2.2xlarge': 8,
	// 	'h1.2xlarge': 8,
	// 	'h1.2xlarge.4': 8,
	// 	'h1.2xlarge.8': 8,
	// 	'h1.4xlarge': 16,
	// 	'h1.4xlarge.4': 16,
	// 	'h1.4xlarge.8': 16,
	// 	'h1.8xlarge': 32,
	// 	'h1.8xlarge.4': 32,
	// 	'h1.8xlarge.8': 32,
	// 	'h1.large': 2,
	// 	'h1.large.4': 2,
	// 	'h1.large.8': 2,
	// 	'h1.xlarge': 4,
	// 	'h1.xlarge.4': 4,
	// 	'h1.xlarge.8': 4,
	// 	'h2.3xlarge.10': 16,
	// 	'h2.3xlarge.20': 16,
	// 	highmem1: 1,
	// 	highmem2: 2,
	// 	highmem3: 4,
	// 	highmem4: 8,
	// 	highmem5: 16,
	// 	'hl1.8xlarge.8': 32,
	// 	'm2.8xlarge.8': 32,
	// 	'm3.15xlarge.8': 60,
	// 	'm3.2xlarge.8': 8,
	// 	'm3.4xlarge.8': 16,
	// 	'm3.8xlarge.8': 32,
	// 	'm3.large.8': 2,
	// 	'm3.xlarge.8': 4,
	// 	'm4.16xlarge.8': 64,
	// 	'm4.2xlarge.8': 8,
	// 	'm4.3xlarge.8': 12,
	// 	'm4.4xlarge.8': 16,
	// 	'm4.6xlarge.8': 24,
	// 	'm4.8xlarge.8': 32,
	// 	'm4.large.8': 2,
	// 	'm4.xlarge.8': 4,
	// 	normal1: 1,
	// 	normal2: 2,
	// 	normal3: 4,
	// 	normal4: 8,
	// 	normal5: 16,
	// 	normal6: 32,
	// 	'p1.2xlarge.8': 8,
	// 	'p1.4xlarge.8': 16,
	// 	'p1.8xlarge.8': 32,
	// 	'p2.2xlarge.8': 8,
	// 	'p2.4xlarge.8': 16,
	// 	'p2.8xlarge.8': 32,
	// 	'p2v.16xlarge.8': 64,
	// 	'p2v.2xlarge.8': 8,
	// 	'p2v.4xlarge.8': 16,
	// 	'p2v.8xlarge.8': 32,
	// 	'physical.h2.large': 36,
	// 	'physical.m2.medium': 192,
	// 	'physical.m2.xlarge': 192,
	// 	'physical.o2.medium': 32,
	// 	'physical.p1.large': 56,
	// 	'physical.p2.large': 56,
	// 	's2.2xlarge.1': 8,
	// 	's2.2xlarge.8': 8,
	// 	's2.4xlarge.1': 16,
	// 	's2.4xlarge.8': 16,
	// 	's2.8xlarge.1': 32,
	// 	's2.8xlarge.2': 32,
	// 	's2.8xlarge.4': 32,
	// 	's2.8xlarge.8': 32,
	// 	's2.large.1': 2,
	// 	's2.large.8': 2,
	// 	's2.medium.1': 1,
	// 	's2.medium.8': 1,
	// 	's2.xlarge.1': 4,
	// 	's2.xlarge.8': 4
	// }
};

mock.onGet('/api/instance-sizes-hash').reply(() => [200, providersDB.hash]);

mock.onGet('/api/providers').reply(() => {
	let list = providersDB.providers;
	
	if (providerData.length > 0) {
		for (const l of list) {
			for (const p of providerData) {
				if (l.id === p.id) {
					l.instanceSizes = p.instanceSizes;
					l.regions = p.regions;
				}
			}
		}
	}

	let hash = {};
	list.forEach(P => {
		if (P.id !== 'local') {
			P.instanceSizes.forEach(I => {
				const key = `${I.instance_id}`;
				const value = { cores: Number(I.cores), gpus: Number(I.gpus) };
				hash[key] = value;
			});
		}
	});

	providersDB.hash = hash;
	return [200, list];
});
